export default class ScoreMutation {
    constructor(scoreName, mutationType, value) {
        this.scoreName = scoreName;
        this.mutationType = mutationType;
        this.value = value;
    }

    setPropertiesFromObject({ scoreName, mutationType, value }) {
        this.scoreName = scoreName;
        this.mutationType = mutationType;
        this.value = value;
    }
}

ScoreMutation.ADD = 0;
ScoreMutation.SET = 1;
ScoreMutation.SUBTRACT = 2;